<template>
  <div class="icon__input">
    <div class="icon__container" @click="openIconSearchModal">
      <i :style="{color: value.color}" :class="value.code"></i>
    </div>
    <rum-button secondary @click="openIconSearchModal">Change Icon</rum-button>
    <i class="tooltip-icon fas fa-question-circle" v-tooltip="'The icon that will be shown with this Channel Page in the Menu.'"></i>
    <rumie-icon-search-modal @change="onChangeIcon" :selectedIcon="value" :recommendations="recommendations" color-disabled/>
  </div>
</template>

<script>
import RumieIconSearchModal from "@/components/ProjectConnect/RumieIconSearchModal";

export default {
  name: "RumieIconInput",
  props: {
    value:  Object,
    recommendations: Array
  },
  components: {
    RumieIconSearchModal
  },
  methods: {
    openIconSearchModal() {
      this.$modal.show("rumie-icon-search-modal");
    },
    onChangeIcon(icon) {
      this.$emit("input", icon);
    }
  }
}
</script>


<style scoped>
.icon__input {
  display: flex;
  align-items: center;
}

.icon__container {
  cursor: pointer;
  width: 60px;
  height: 60px;
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: var(--grey-lighter);
  color: var(--black);
  margin-right: var(--spacing-4);
  font-size: var(--xl2);
  border-radius: var(--border-radius-lg);
}

.tooltip-icon {
  margin-left: 10px;
}
</style>
